import { State } from '../index';
import { se } from 'module/Common';
import { createSelector } from 'reselect';
import { MenuItem, MenuItemType, MenuItemCategoryLinkMultiple, MenuItemCategoryLink } from 'module/Model/Menu';
import { Wish } from 'module/Model/Wish';

export namespace MenuSelector {
  export const isOpen = (s: State) => se(s, 'menuOpen', s.menuOpen);
  export const selectMenu = (s: State) => se(s, 'menu', s.menu);

  export const selectCategoriesIdInMenu = createSelector(selectMenu, (menuWish): Wish<Array<number>> => {
    return Wish.transform(menuWish, menu => {
      return menu.reduce<Array<number>>((acc, menuItem) => {
        switch (MenuItem.getType(menuItem)) {
          case MenuItemType.CategoryLinkMultiple:
            acc.push(...MenuItemCategoryLinkMultiple.getCategoryIds(menuItem as any));
            break;
          case MenuItemType.CategoryLink:
            acc.push(MenuItemCategoryLink.getCategoryId(menuItem as any));
            break;
        }
        return acc;
      }, []);
    });
  });
}



// WEBPACK FOOTER //
// ./src/module/Redux/Menu/MenuSelector.ts